module.exports = __webpack_public_path__ + "static/media/poo_default.69c42640.png";